import { FC, Fragment } from 'react';

import { getFormattedIntNumber } from 'utils/clickme';
import { NON_BREAKING_SPACE } from 'utils/constants/common';

import dashboardBannerButtonClick from '@hh.ru/analytics-js-events/build/clickme/employer/common/dashboard_banner_button_click';
import dashboardCampaignButtonClick from '@hh.ru/analytics-js-events/build/clickme/employer/common/dashboard_campaign_button_click';
import { Link } from '@hh.ru/redux-spa-middleware';

import Conversion from 'bloko/blocks/conversion';
import BlokoLink from 'bloko/blocks/link';

import useTrls from 'hooks/translation/useTrls';

interface StatisticLinkProps {
    clicks: number;
    ctr: number;
    amount: number;
    shows: number;
    action: string;
    dataQa: string;
    campaignId: number;
    bannerId?: number;
}

const StatisticLink: FC<StatisticLinkProps> = ({ clicks, amount, shows, action, dataQa, campaignId, bannerId }) => {
    const trl = useTrls();

    const sendAnalytics = () => {
        if (bannerId) {
            dashboardBannerButtonClick({ buttonName: 'banner_statistics', campaignId, bannerId });
        } else {
            dashboardCampaignButtonClick({ buttonName: 'campaign_statistics', campaignId });
        }
    };

    const statistic = (
        <Fragment>
            {getFormattedIntNumber(shows)}
            {NON_BREAKING_SPACE}
            <Conversion
                zero={trl('campaign.statistic.shows.zero')}
                one={trl('campaign.statistic.shows.one')}
                some={trl('campaign.statistic.shows.some')}
                many={trl('campaign.statistic.shows.many')}
                value={shows}
                hasValue={false}
            />
            {', '}
            {getFormattedIntNumber(clicks)}
            {NON_BREAKING_SPACE}
            <Conversion
                zero={trl('campaign.statistic.clicks.zero')}
                one={trl('campaign.statistic.clicks.one')}
                some={trl('campaign.statistic.clicks.some')}
                many={trl('campaign.statistic.clicks.many')}
                value={clicks}
                hasValue={false}
            />
            {', '}
            {getFormattedIntNumber(amount)}
            {NON_BREAKING_SPACE}
            {trl('currency.short')}
        </Fragment>
    );
    if (shows === 0) {
        return statistic;
    }
    return (
        <BlokoLink Element={Link} to={action} onClick={sendAnalytics} data-qa={dataQa}>
            {statistic}
        </BlokoLink>
    );
};

export default StatisticLink;
